

export const redodnearHora = (hora) => {
    const minutos = Math.floor(hora.format("mm") / 10) * 10;
    return hora.minutes(minutos).clone();
} 
